import React, { useEffect } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PaginateSupplierState } from 'store/ducks/settings/suppliers';

import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridSupplier, FilterSupplier } from 'components/settings';
import { useFilters } from 'hooks/useFilters';

export const ListSupplier: React.FC = () => {
  const { getTranslation } = useTranslation(translations);
  const history = useHistory();
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('suppliers');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateSupplier
  ) as PaginateSupplierState;

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')}
          <MenuSelector page="supplier" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertSupplier') && (
            <S.ButtonMini
              onClick={() => history.push('/settings/supplier/new')}
            >
              {getTranslation('novoBtn')}
            </S.ButtonMini>
          )}
          <FilterSupplier />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridSupplier supplier={data} />
        <Paginator
          pagination={pagination}
          settingsPage='suppliers'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
